import { render, staticRenderFns } from "./AssignShortCode.vue?vue&type=template&id=1e54abca&scoped=true"
import script from "./AssignShortCode.vue?vue&type=script&lang=js"
export * from "./AssignShortCode.vue?vue&type=script&lang=js"
import style0 from "./AssignShortCode.vue?vue&type=style&index=0&id=1e54abca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e54abca",
  null
  
)

export default component.exports